module.exports = __webpack_public_path__ + "media/corner_lot.b7486f71.svg";